"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.windowScrollPolyfill = exports.windowScroll = void 0;
const scrollable_1 = require("../../components/scrollable");
const common_1 = require("../common");
let context;
const windowScroll = (options) => {
    var _a, _b, _c;
    const originalBoundFunc = common_1.original.windowScroll.bind(window);
    if (!(0, common_1.doesOverrideDefaultScrollBehavior)()) {
        originalBoundFunc(options);
        return;
    }
    if (options.left === undefined && options.top === undefined) {
        return;
    }
    const startX = window.scrollX || window.pageXOffset;
    const startY = window.scrollY || window.pageYOffset;
    const targetX = (0, common_1.nonFinite)((_a = options.left) !== null && _a !== void 0 ? _a : startX);
    const targetY = (0, common_1.nonFinite)((_b = options.top) !== null && _b !== void 0 ? _b : startY);
    const removeEventListener = () => {
        window.removeEventListener('wheel', cancelScroll);
        window.removeEventListener('touchmove', cancelScroll);
    };
    let duration = 750;
    const scrollSpeed = (_c = (0, scrollable_1.getBodyScrollable)()) === null || _c === void 0 ? void 0 : _c.getScrollSpeed();
    if (scrollSpeed && scrollSpeed > 0) {
        duration = scrollSpeed;
    }
    if (context) {
        cancelAnimationFrame(context.rafId);
    }
    context = {
        timeStamp: (0, common_1.now)(),
        duration,
        startX,
        startY,
        targetX,
        targetY,
        rafId: 0,
        method: originalBoundFunc,
        callback: removeEventListener,
        href: window.location.href,
    };
    const cancelScroll = () => {
        cancelAnimationFrame(context.rafId);
        removeEventListener();
    };
    if (options.behavior !== 'smooth') {
        return originalBoundFunc(targetX, targetY);
    }
    window.addEventListener('wheel', cancelScroll, {
        passive: true,
        once: true,
    });
    window.addEventListener('touchmove', cancelScroll, {
        passive: true,
        once: true,
    });
    (0, common_1.step)(context);
};
exports.windowScroll = windowScroll;
const windowScrollPolyfill = (animationOptions) => {
    if ((0, common_1.isScrollBehaviorSupported)()) {
        return;
    }
    const originalFunc = common_1.original.windowScroll;
    window.scroll = function scroll() {
        if (arguments.length === 1) {
            const scrollOptions = arguments[0];
            if (!(0, common_1.isObject)(scrollOptions)) {
                throw new TypeError("Failed to execute 'scroll' on 'Window': parameter 1 ('options') is not an object.");
            }
            return (0, exports.windowScroll)(Object.assign(Object.assign({}, scrollOptions), animationOptions));
        }
        return originalFunc.apply(this, arguments);
    };
};
exports.windowScrollPolyfill = windowScrollPolyfill;
//# sourceMappingURL=data:application/json;base64,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